"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : BODYCOPY : STYLES --------------- ++++++++++ */


var _default = {
  bodycopy: {
    color: _index.theme.color.supporting.dark.swatch,
    margin: '0 auto',
    position: 'relative',
    // maxWidth: pxToEm(650),
    // elements
    '& p, ul, ol': {
      extend: _index.theme.typography.size.small,
      marginBottom: (0, _index.pxToRem)(20)
    },
    '& ul, ol': {
      paddingLeft: (0, _index.pxToEm)(30)
    },
    // generates classes for every size in the theme ".size-(uniqueColor)"
    extend: (0, _index.themeStyleHelper)(_index.theme.typography, 'size', function (theme, uniqueProp) {
      return {
        '& p, ul, ol': {
          extend: theme.size[uniqueProp]
        }
      };
    })
  }
};
exports.default = _default;